import { LanguageManagementRepository } from '../data/language-management-repository';
import { LanguageListResponse } from '../types/language-management-types';

/**
 * Get All Languages Use Case
 * Retrieves all global languages for management
 */
export class GetAllLanguagesUseCase {
  constructor(private readonly repository: LanguageManagementRepository) {}

  async execute(): Promise<LanguageListResponse> {
    return this.repository.getLanguages();
  }
}
